import { css, CSSResult } from 'lit'
import {
  csColorAction,
  csColorBackground,
  csColorBorder,
  csColorFunctional,
  csColorText
} from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder, csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csFontBody } from 'elements/_shared/fonts.style.js'


export const cseButton = {
  backgroundColorDisabled: css`var(--cse-button-background-color-disabled, ${csColorBackground.disabled})`,
  borderColorDisabled: css`var(--cse-button-border-color-disabled, ${csColorBorder.light})`,
  borderRadius: css`var(--cse-button-border-radius, ${csBorder.radiusMinimal})`,
  borderWidth: css`var(--cse-button-border-width, ${csBorder.width})`,
  colorDisabled: css`var(--cse-button-color-disabled, ${csColorText.muted})`,
  columnGap: css`var(--cse-button-column-gap, ${csSpacing.spacing05})`,
  fontFamily: css`var(--cse-button-font-family, ${csFontBody.fontFamily})`,
  fontSize: css`var(--cse-button-font-size, ${csFontBody.fontSize})`,
  fontWeight: css`var(--cse-button-font-weight, 400)`,
  lineHeight: css`var(--cse-button-line-height, normal)`,
  textTransform: css`var(--cse-button-text-transform, none)`,
  height: css`var(--cse-button-height, 48px)`,
  paddingBlock: css`var(--cse-button-padding-y, ${csSpacing.spacing05})`,
  paddingInline: css`var(--cse-button-padding-x, ${csSpacing.spacing07})`,

  smallFontSize: css`var(--cse-button-small-font-size, ${csFontBody.fontSize})`,
  smallFontWeight: css`var(--cse-button-small-font-weight, 400)`,
  smallLineHeight: css`var(--cse-button-small-line-height, normal)`,
  smallHeight: css`var(--cse-button-small-height, 40px)`,
  smallPaddingBlock: css`var(--cse-button-small-padding-y, ${csSpacing.spacing04})`,
  smallPaddingInline: css`var(--cse-button-small-padding-x, ${csSpacing.spacing06})`,

  defaultColor: css`var(--cse-button-default-color, ${csColorText.headings})`,
  defaultColorHover: css`var(--cse-button-default-color-hover, ${csColorText.white})`,
  defaultBackgroundColor: css`var(--cse-button-default-background-color, ${csColorBackground.primary})`,
  defaultBackgroundColorHover: css`var(--cse-button-default-background-color-hover, ${csColorAction.secondary})`,
  defaultBorderColor: css`var(--cse-button-default-border-color, ${csColorAction.secondary})`,
  defaultBorderColorHover: css`var(--cse-button-default-border-color-hover, ${csColorAction.secondary})`,

  primaryColor: css`var(--cse-button-primary-color, ${csColorText.white})`,
  primaryColorHover: css`var(--cse-button-primary-color-hover, ${csColorText.white})`,
  primaryBackgroundColor: css`var(--cse-button-primary-background-color, ${csColorAction.primary})`,
  primaryBackgroundColorHover: css`var(--cse-button-primary-background-color-hover, ${csColorAction.primaryHover})`,
  primaryBorderColor: css`var(--cse-button-primary-border-color, ${csColorAction.primary})`,
  primaryBorderColorHover: css`var(--cse-button-primary-border-color-hover, ${csColorAction.primaryHover})`,

  secondaryColor: css`var(--cse-button-secondary-color, ${csColorText.white})`,
  secondaryColorHover: css`var(--cse-button-secondary-color-hover, ${csColorText.white})`,
  secondaryBackgroundColor: css`var(--cse-button-secondary-background-color, ${csColorAction.secondary})`,
  secondaryBackgroundColorHover: css`var(--cse-button-secondary-background-color-hover, ${csColorAction.secondaryHover})`,
  secondaryBorderColor: css`var(--cse-button-secondary-border-color, ${csColorAction.secondary})`,
  secondaryBorderColorHover: css`var(--cse-button-secondary-border-color-hover, ${csColorAction.secondaryHover})`,

  errorColor: css`var(--cse-button-error-color, ${csColorText.white})`,
  errorColorHover: css`var(--cse-button-error-color-hover, ${csColorText.white})`,
  errorBackgroundColor: css`var(--cse-button-error-background-color, ${csColorFunctional.error})`,
  errorBackgroundColorHover: css`var(--cse-button-error-background-color-hover, ${csColorFunctional.errorHover})`,
  errorBorderColor: css`var(--cse-button-error-border-color, ${csColorFunctional.error})`,
  errorBorderColorHover: css`var(--cse-button-error-border-color-hover, ${csColorFunctional.errorHover})`,

  infoColor: css`var(--cse-button-info-color, ${csColorText.white})`,
  infoColorHover: css`var(--cse-button-info-color-hover, ${csColorText.white})`,
  infoBackgroundColor: css`var(--cse-button-info-background-color, ${csColorFunctional.info})`,
  infoBackgroundColorHover: css`var(--cse-button-info-background-color-hover, ${csColorFunctional.infoHover})`,
  infoBorderColor: css`var(--cse-button-info-border-color, ${csColorFunctional.info})`,
  infoBorderColorHover: css`var(--cse-button-info-border-color-hover, ${csColorFunctional.infoHover})`,

  successColor: css`var(--cse-button-success-color, ${csColorText.white})`,
  successColorHover: css`var(--cse-button-success-color-hover, ${csColorText.white})`,
  successBackgroundColor: css`var(--cse-button-success-background-color, ${csColorFunctional.success})`,
  successBackgroundColorHover: css`var(--cse-button-success-background-color-hover, ${csColorFunctional.successHover})`,
  successBorderColor: css`var(--cse-button-success-border-color, ${csColorFunctional.success})`,
  successBorderColorHover: css`var(--cse-button-success-border-color-hover, ${csColorFunctional.successHover})`,

  warningColor: css`var(--cse-button-warning-color, ${csColorText.white})`,
  warningColorHover: css`var(--cse-button-warning-color-hover, ${csColorText.white})`,
  warningBackgroundColor: css`var(--cse-button-warning-background-color, ${csColorFunctional.warning})`,
  warningBackgroundColorHover: css`var(--cse-button-warning-background-color-hover, ${csColorFunctional.warningHover})`,
  warningBorderColor: css`var(--cse-button-warning-border-color, ${csColorFunctional.warning})`,
  warningBorderColorHover: css`var(--cse-button-warning-border-color-hover, ${csColorFunctional.warningHover})`,
}

export const style: CSSResult = css`
  .cse-button {
    align-items: center;
    background-color: ${cseButton.defaultBackgroundColor};
    border-radius: ${cseButton.borderRadius};
    border-width: ${cseButton.borderWidth};
    border-style: solid;
    border-color: ${cseButton.defaultBorderColor};
    color: ${cseButton.defaultColor};
    column-gap: ${cseButton.columnGap};
    cursor: pointer;
    display: inline-flex;
    font-family: ${cseButton.fontFamily};
    justify-content: center;
    position: relative;
    text-decoration: none;
    text-transform: ${cseButton.textTransform};
    transition-duration: ${csTransition.duration};
    transition-property: border-color, color, background-color;
    transition-timing-function: ${csTransition.timingFunction};
  }

  .cse-button.full-width {
    width: 100%;
  }

  .cse-button:not(.size-small) {
    padding-block: ${cseButton.paddingBlock};
    padding-inline: ${cseButton.paddingInline};
    height: ${cseButton.height};
    max-height: ${cseButton.height};
    font-size: ${cseButton.fontSize};
    font-weight: ${cseButton.fontWeight};
    line-height: ${cseButton.lineHeight};
  }

  .cse-button.size-small {
    padding-block: ${cseButton.smallPaddingBlock};
    padding-inline: ${cseButton.smallPaddingInline};
    height: ${cseButton.smallHeight};
    max-height: ${cseButton.smallHeight};
    font-size: ${cseButton.smallFontSize};
    font-weight: ${cseButton.smallFontWeight};
    line-height: ${cseButton.smallLineHeight};
  }

  .cse-button:hover {
    background-color: ${cseButton.defaultBackgroundColorHover};
    border-color: ${cseButton.defaultBorderColorHover};
    color: ${cseButton.defaultColorHover};
  }

  .cse-button:disabled {
    cursor: default;
    background-color: ${cseButton.backgroundColorDisabled};
    border-color: ${cseButton.borderColorDisabled};
    color: ${cseButton.colorDisabled};
  }

  .square {
    padding: 0;
    justify-content: center;
    max-width: ${cseButton.height};
    width: ${cseButton.height};;
  }

  .size-small.square {
    max-width: ${cseButton.smallHeight};
    width: ${cseButton.smallHeight};
  }

  /* VARIANTS */
  .variant-primary:not(:disabled) {
    background-color: ${cseButton.primaryBackgroundColor};
    border-color: ${cseButton.primaryBorderColor};
    color: ${cseButton.primaryColor};
  }

  .variant-primary:not(:disabled):hover {
    background-color: ${cseButton.primaryBackgroundColorHover};
    border-color: ${cseButton.primaryBorderColorHover};
    color: ${cseButton.primaryColorHover};
  }

  .variant-secondary:not(:disabled) {
    background-color: ${cseButton.secondaryBackgroundColor};
    border-color: ${cseButton.secondaryBorderColor};
    color: ${cseButton.secondaryColor};
  }

  .variant-secondary:not(:disabled):hover {
    background-color: ${cseButton.secondaryBackgroundColorHover};
    border-color: ${cseButton.secondaryBorderColorHover};
    color: ${cseButton.secondaryColorHover};
  }

  .variant-error:not(:disabled) {
    background-color: ${cseButton.errorBackgroundColor};
    border-color: ${cseButton.errorBorderColor};
    color: ${cseButton.errorColor};
  }

  .variant-error:not(:disabled):hover {
    background-color: ${cseButton.errorBackgroundColorHover};
    border-color: ${cseButton.errorBorderColorHover};
    color: ${cseButton.errorColorHover};
  }

  .variant-info:not(:disabled) {
    background-color: ${cseButton.infoBackgroundColor};
    border-color: ${cseButton.infoBorderColor};
    color: ${cseButton.infoColor};
  }

  .variant-info:not(:disabled):hover {
    background-color: ${cseButton.infoBackgroundColorHover};
    border-color: ${cseButton.infoBorderColorHover};
    color: ${cseButton.infoColorHover};
  }

  .variant-success:not(:disabled) {
    background-color: ${cseButton.successBackgroundColor};
    border-color: ${cseButton.successBorderColor};
    color: ${cseButton.successColor};
  }

  .variant-success:not(:disabled):hover {
    background-color: ${cseButton.successBackgroundColorHover};
    border-color: ${cseButton.successBorderColorHover};
    color: ${cseButton.successColorHover};
  }

  .variant-warning:not(:disabled) {
    background-color: ${cseButton.warningBackgroundColor};
    border-color: ${cseButton.warningBorderColor};
    color: ${cseButton.warningColor};
  }

  .variant-warning:not(:disabled):hover {
    background-color: ${cseButton.warningBackgroundColorHover};
    border-color: ${cseButton.warningBorderColorHover};
    color: ${cseButton.warningColorHover};
  }
`

export const buttonGroupStyle = css`
  :host([slot="left"]) .cse-button {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
  }

  :host([slot="right"]) .cse-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
    margin-left: -1px;
  }
`
